import _ from 'lodash'
import { Set } from 'immutable'

import { toMoment } from 'utils/datetime'
import { createDeepEqualSelector } from 'utils/selectors'

export const getOrderedDates = state => state.grid.dates

export const getOrderedTimes = state => state.grid.times

export const getSellableItem = sellableItemId => state => state.grid.sellableItems.get(sellableItemId)

export const getSellableItems = createDeepEqualSelector(
  [state => state.grid.sellableItems],
  sellableItems => sellableItems.filterNot(sellableItem => sellableItem.deleted)
)

export const getDeals = createDeepEqualSelector(
  [state => state.grid.deals],
  deals => deals.filterNot(deal => deal.deleted)
)

export const getDateTimeDealIds = _.memoize(
  (dateId, timeId) => createDeepEqualSelector(
    [state => state.grid.datesToTimesToDeals],
    datesToTimesToDeals => datesToTimesToDeals.getIn([dateId, timeId], new Set())
  ),
  (dateId, timeId) => `${dateId}-${timeId}`
)

export const getDateTimeDeals = _.memoize(
  (dateId, timeId) => createDeepEqualSelector(
    [getDateTimeDealIds(dateId, timeId), getDeals],
    (dateTimeDealIds, deals) => dateTimeDealIds.map(dealId => deals.get(dealId))
  ),
  (dateId, timeId) => `${dateId}-${timeId}`
)

export const getDatesToTimesToDeals = state => state.grid.datesToTimesToDeals

export const getGridRecomputeTime = state => state.grid.gridRecomputeTime

export const getDatePickerDates = state => state.grid.datePickerDates.toArray().map(date => date.date)

export const getPerformanceId = (dateId, timeId) => state => {
  const selectedDeal = getDateTimeDeals(dateId, timeId)(state).find(deal => deal.performanceId)
  return selectedDeal ? selectedDeal.performanceId : null
}

export const getDealStartTime = dealId => state => {
  let dealStartTime = null
  state.grid.datesToTimesToDeals.forEach((timesToDeals, dateId) => {
    timesToDeals.forEach((dealSet, timeId) => {
      if (dealSet.has(dealId)) {
        const date = state.grid.dates.get(dateId)
        const time = state.grid.times.get(timeId)
        dealStartTime = toMoment(`${date.date} ${time.hour}:${time.minute}`)
      }
    })
  })
  return dealStartTime
}

export const getCreatedSellableItems = state =>
  state.grid.sellableItems.filter(sellableItem => !sellableItem.deleted && !sellableItem.serverId).toArray()

export const getUpdatedSellableItems = state =>
  state.grid.sellableItems.filter(sellableItem =>
    !sellableItem.deleted && sellableItem.serverId && sellableItem.updated
  ).toArray()

export const getDeletedSellableItems = state =>
  state.grid.sellableItems.filter(sellableItem => sellableItem.deleted && sellableItem.serverId).toArray()

export const getCreatedDeals = state => state.grid.deals.filter(deal => !deal.deleted && !deal.serverId).toArray()

export const getDeletedDeals = state => state.grid.deals.filter(deal => deal.deleted && deal.serverId).toArray()

export const getIsLoading = state => state.grid.isLoading

export const getIsSaving = state => state.grid.isSaving

export const getCurrentEditSellableItemId = state => state.grid.currentEditingSellableItemId

export const getOperationError = state => state.grid.operationError



/** WEBPACK FOOTER **
 ** ./src/selectors/grid/grid-selectors.js
 **/